import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import DocumentFormUpload from "./DocumentFormUpload";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const DocumentFormUploadView = ({props, ...rest}) => {
  const classes = useStyles();

  let pageTitle = "Dodaj wiele dokumentów";

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
      { pageTitle }
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <DocumentFormUpload />
        </Box>
      </Container>
    </Page>
  );
};

export default DocumentFormUploadView;
